exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dressingRoom{display:flex;height:545px}.dressingRoom .modalBackground{position:absolute;left:0;top:0;width:100%;height:100%;max-width:100%;max-height:100%;border-bottom-left-radius:5px;border-bottom-right-radius:5px}.dressingRoom .owlvatarControl{display:flex;flex-direction:column;align-items:center;position:static;margin-top:18%}.dressingRoom .owlvatarControl .owlvatar{padding-left:3rem;padding-right:3rem}.dressingRoom .owlvatarControl .saveButton{z-index:10000;width:70%}.dressingRoom .dressingPatcher{display:flex;flex-direction:column;z-index:10000;width:73%;justify-content:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/games/dressing_room.scss
// module id = 1291
// module chunks = 0